/** Steps of the "Add members from a file" wizard, in order. Values are stable ids. */
export const IMPORT_STEPS = Object.freeze({
  UPLOAD: 'upload',
  MATCH: 'match',
  REVIEW: 'review',
  CHECK: 'check',
});

export const IMPORT_STEP_ORDER = Object.freeze([
  IMPORT_STEPS.UPLOAD,
  IMPORT_STEPS.MATCH,
  IMPORT_STEPS.REVIEW,
  IMPORT_STEPS.CHECK,
]);
